@if (followers$ | async; as followers) {
  @if (followers?.length) {
    <div class="followers">
      @if (divider) {
        <div class="divider"></div>
      }
      <div class="followers__section">
        @if (!!followers?.length) {
          <p>
            <sharry-icon
              name="land-follow-active"
              type="custom"
              svgClass="svg-icon"></sharry-icon>
            <span
              [innerHTML]="
                followers?.length | i18nPlural: itemPluralMapping['followers'] | i18next: { people: followers?.length }
              "></span>
          </p>
        }
        <div class="followers__box">
          <div class="followers__avatars-container cursor-pointer">
            <sharry-people-avatar-list
              class="is-not-mobile-not-ipad"
              [users]="followers"
              [maxLength]="6"
              (peopleClicked)="
                !loading && onPeopleClick(); $event.stopPropagation(); $event.preventDefault()
              "></sharry-people-avatar-list>
            <sharry-people-avatar-list
              class="is-mobile-not-ipad is-not-xxxs"
              [users]="followers"
              [maxLength]="4"
              (peopleClicked)="
                !loading && onPeopleClick(); $event.stopPropagation(); $event.preventDefault()
              "></sharry-people-avatar-list>
            <sharry-people-avatar-list
              class="is-mobile-not-ipad is-xxxs"
              [users]="followers"
              [maxLength]="1"
              (peopleClicked)="
                !loading && onPeopleClick(); $event.stopPropagation(); $event.preventDefault()
              "></sharry-people-avatar-list>
          </div>
        </div>
      </div>
    </div>
  }
}
